import React, { useState } from 'react'
import { Button, Modal, ModalControlsStyled } from '@clickcease/cc-client-components-lib'

import { useTranslation } from 'react-i18next'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { Plan } from 'Features/pricing/types/Plan'
import {
  SwitchPaymentIntervalContainerBody,
  SwitchPaymentIntervalContainerModal,
  SwitchPaymentIntervalError,
} from './CurrentPlanDetails.styled'
import { getAmountWithCurrency } from 'Utils/currencyHelper'
import { useUpdatePlan } from 'Features/CrossSell/CrosSellPricing/api/useUpdatePlan'

interface SwitchPaymentIntervalModalProps {
  isOpen?: boolean
  onOpenChange: () => void
  plans: Plan[]
  isInstallmentsSubscription: boolean
}

export const SwitchPaymentIntervalModal = ({
  isOpen,
  onOpenChange,
  plans,
  isInstallmentsSubscription,
}: SwitchPaymentIntervalModalProps) => {
  const { showToaster } = useAppStore()
  const { mutate } = useUpdatePlan()
  const [error, setError] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const { t } = useTranslation('accountSettings')
  const totalAmount: number = (() => {
    let totalCost = 0
    if (plans.length === 1) {
      totalCost = Math.round(plans[0].amount)
    } else {
      const costBundle = plans.reduce(
        (accumulator, currentPlan) => accumulator + currentPlan.amount,
        0
      )
      totalCost = Math.round(costBundle * 0.85)
    }
    return totalCost
  })()
  const amount = plans.reduce((accumulator, currentPlan) => accumulator + currentPlan.amount, 0)
    ? `${getAmountWithCurrency(plans[0]?.currency.toLocaleLowerCase(), totalAmount)}`
    : ''
  const subscribeToNewPaymentInterval = () => {
    setIsLoading(true)
    mutate(
      { products: plans.map((plan) => plan.id), hideErrorToaster: true },
      {
        onSuccess: (res) => {
          setIsLoading(false)
          if (!(res instanceof Error)) {
            onOpenChange()
            showToaster(
              t('plan_details.switch_payment_interval_modal.switch_successfully'),
              'success'
            )
          } else {
            setError(t('plan_details.switch_payment_interval_modal.error_has_occurred'))
          }
        },
      }
    )
  }

  return (
    <Modal
      title={t('plan_details.switch_payment_interval_modal.title')}
      isOpen={isOpen}
      loading={isLoading}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
    >
      <SwitchPaymentIntervalContainerModal>
        <SwitchPaymentIntervalContainerBody>
          {isInstallmentsSubscription
            ? t('plan_details.switch_payment_interval_modal.confirm_change_to_annual', {
                amount: amount,
              })
            : t('plan_details.switch_payment_interval_modal.confirm_change_to_monthly', {
                amount: amount,
              })}
        </SwitchPaymentIntervalContainerBody>

        <ModalControlsStyled>
          <Button variant="ghost" onClick={onOpenChange} disabled={isLoading}>
            {t('plan_details.switch_payment_interval_modal.cancel')}
          </Button>
          <Button onClick={() => subscribeToNewPaymentInterval()}>
            {t('plan_details.switch_payment_interval_modal.confirm')}
          </Button>{' '}
        </ModalControlsStyled>
        {error && <SwitchPaymentIntervalError>{error}</SwitchPaymentIntervalError>}
      </SwitchPaymentIntervalContainerModal>
    </Modal>
  )
}
